'use strict';

module.exports = function isNegativeZero(number) {
	return number === 0 && (1 / number) === -Infinity;
};




//////////////////
// WEBPACK FOOTER
// ./node_modules/is-negative-zero/index.js
// module id = 600
// module chunks = 0 1